'use strict'

module.exports = bail

function bail(err) {
  if (err) {
    throw err
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/bail/index.js
// module id = ./node_modules/bail/index.js
// module chunks = 0